module.exports = __webpack_public_path__ + "5f8323937b7f7e5fec60edfc89d239f8.jpeg";